import type { ReactNode, Ref } from 'react';

interface CalculatorShellProps {
  title: string;
  /** A node, because some legal copy cites a source it has to link. */
  disclaimer: ReactNode;
  /** Announced on change; keep result detail too long to hear out of it. */
  summary?: ReactNode;
  /** Focus target after a calculation. */
  summaryRef?: Ref<HTMLDivElement>;
  /**
   * Results shown beside the form rather than in place of it. Passing anything - including a falsy
   * placeholder - reserves the second column, so it does not appear on the first calculation.
   */
  results?: ReactNode;
  children: ReactNode;
}

export const CalculatorShell = ({
  title,
  disclaimer,
  summary,
  summaryRef,
  results,
  children,
}: CalculatorShellProps) => (
  <div className="rounded-xl bg-bg-raised-secondary p-6 font-sans [--btn-outline-hover:var(--color-kale)] [--btn-outline:var(--color-kale)] sm:p-10">
    {/* The page provides the h1. */}
    <h2 className="mb-6 text-heading-md">{title}</h2>

    <div role="status" ref={summaryRef} tabIndex={-1}>
      {summary}
    </div>

    {/* `md` is 1025px here; at `sm` the inner card is too narrow for a form and a chart side by side. */}
    {results === undefined ? (
      children
    ) : (
      <div className="grid gap-8 md:grid-cols-2">
        {children}
        {results}
      </div>
    )}

    <p className="mt-8 text-legal">{disclaimer}</p>
  </div>
);
